import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { permissionCheck } from '../../../../app/helper-functions/PermissionCheck';
import { useNavigate } from 'react-router-dom';
let organization_add,organization_activity_log,organization_view;
function OrganizationAside() {
    const navigate=useNavigate();
  useEffect(() => {
    navigate("/hr/organization-managements/organization/add-organization")
  }, [])
    const intl = useIntl();
    organization_add = permissionCheck('organization-create')
    organization_view = permissionCheck('organization-view')
    organization_activity_log = permissionCheck('organization-activity-log')
    return (
        <>
            <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Organization</span>
                </div>
            </div>
            { organization_view ?(
            <AsideMenuItemWithSub
                to='/hr/organization-managements/organization'
                title='Organization Management'
                fontIcon='bi-archive'
                icon='fa fa-building-columns'
            >
               {
                organization_view && (
                    <AsideMenuItem 
                    to='/hr/organization-managements/organization/add-organization' 
                    title='Manage Organization' 
                    hasBullet={true} 
                />
                )
               }
                {
                    organization_view && (
                    <AsideMenuItem 
                        to='/hr/organization-managements/organization/all-organization-logs' 
                        title='Organization Activity Logs' 
                        hasBullet={true} 
                    />
                    )
                }
            </AsideMenuItemWithSub>
            ):null}
        </>
    )
}

export default OrganizationAside;
